'use client';
import { useState } from 'react';

export default function useToggle() {
  const [isToggled, setIsToggled] = useState(false);
  const toggle = () => setIsToggled((prevState: boolean) => !prevState);
  return { isToggled, toggle };
}
